import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import { useState } from "react"
import axios from "axios"
import { toast } from "react-toastify"
import { AddList } from "./useAddList"

export interface VesselTrackingList extends AddList{
  id: string
}

export function useFetchList() {
  const request = useAxiosRequest()
  async function GetList() {
    return request<any, VesselTrackingList[]>({
      url: `${BASE_URL}/vesseltracking/list`,
      method: "GET",
    }).then((response) => response?.data)
  }
  const [vesselTrackingList, setVesselTrackingList] = useState<
    VesselTrackingList[] | undefined
  >([])
  const [getVesselListLoading, setGetVesselListLoading] =
    useState<boolean>(false)

  async function fetchVesselTrackingList() {
    setVesselTrackingList(undefined)
    setGetVesselListLoading(true)
    try {
      const response = await GetList()
      if (response) {
        setVesselTrackingList(response)
      }
    } catch (err: unknown) {
      const message = "Unable to load vessel tracking lists"
      if (axios.isAxiosError(err)) {
        toast.warn(message, {
          position: "bottom-right",
          autoClose: 8000,
        })
      }
    } finally {
      setGetVesselListLoading(false)
    }
  }
  function appendVesselTrackingList(list: VesselTrackingList) {
    setVesselTrackingList((prev) => [...(prev ?? []), list])
  }

  return {
    vesselTrackingList,
    fetchVesselTrackingList,
    appendVesselTrackingList,
    getVesselListLoading,
  }
}
